export default {
  SEVERITY: {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warn',
    ERROR: 'error'
  }
};